import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BreadCrumbsImg from "../Assets/img/web-knowledge/w-knowledge-img.svg";
import ExploreTopic from "../Components/ExploreTopic";
import KnowledgeBaseTicket from "../Components/KnowledgeBaseTicket";

const KnowledgeBase = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <!-- BreadCrumb --> */}
      <section className="a-isp-area knowledge">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="knowledge-hero-menu">
                <ul className="k-menu-inner">
                  <li>
                    <Link to="/">Home</Link>
                    <i className="fa fa-angle-right"></i>
                  </li>
                  <li className="active">
                    <Link to="/knowledgebase">Knowledge base</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="a-isp-content">
                <h1>Knowledge Base</h1>
                <p>
                  We did our best to cover all topics related to this product.
                  Each section have number which represent number of topic in
                  each category.
                </p>
              </div>
              <div className="k-base-hero-search">
                <form action="#" className="search-field">
                  <div className="form-top">
                    <input type="text" placeholder="ex: 350222" required />
                    <i className="icofont-search-1"></i>
                  </div>
                  <button className="search-t-btn" type="submit">
                    Search tickets
                  </button>
                </form>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className="a-isp-img">
                <img src={BreadCrumbsImg} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End BreadCrumb -->	 */}
      <ExploreTopic />
      <KnowledgeBaseTicket />
    </>
  );
};

export default KnowledgeBase;
